import { render, staticRenderFns } from "./contactPerson.vue?vue&type=template&id=37dd3141"
import script from "./contactPerson.vue?vue&type=script&lang=js"
export * from "./contactPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports